export const generateUUID = () => {
  // Public Domain/MIT
  let d = new Date().getTime();
  // eslint-disable-next-line no-undef
  // @ts-ignore: Let's ignore a compile error like this unreachable code
  // eslint-disable-next-line no-undef
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    // eslint-disable-next-line no-undef
    // @ts-ignore: Let's ignore a compile error like this unreachable code
    // eslint-disable-next-line no-undef
    d += performance.now(); // use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    // eslint-disable-next-line no-bitwise
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};
